import type { ComputedRef } from "vue";
import { DSSelectProps } from "@/src/design_system/form_elements/select/types/props";

interface UseSelectTypeaheadKeydownArgs {
  props: ComputedRef<Readonly<DSSelectProps>>;
  onAlphabeticKey: (key: string) => void;
}

interface UseSelectTypeaheadKeydown {
  onKeydown: (event: KeyboardEvent) => void;
}

const keyboardEventIsAlphabetic = (event: KeyboardEvent): boolean => /^[a-zA-Z0-9]$/.test(event.key);

export const useSelectTypeaheadKeydown = ({
  props,
  onAlphabeticKey,
}: UseSelectTypeaheadKeydownArgs): UseSelectTypeaheadKeydown => {
  const onKeydown = (event: KeyboardEvent) => {
    if (
      keyboardEventIsAlphabetic(event) &&
      !props.value.autocomplete &&
      !props.value.multiple &&
      !props.value.disabled
    ) {
      event.preventDefault();
      onAlphabeticKey(event.key);
    }
  };

  return { onKeydown };
};
